<template>
	<div class="app">
		<a :href="URL" :target="target" class="livadvert" :class="config.Settings.typeOfAdvert" :data-targetid="config.Settings.targetID"><img :src="originLocation+imagePath" alt=""></a>
	</div>
</template>

<script>
import mtapi from './mtapi'

export default {
  name: 'display',
  props: ['ContentKey', 'ContentItemKey'],
  components: {},
  data () {
    return {
      ready: false,
      config: {
        Settings: {}
      },
      originLocation: window.location.origin,
      imagePath:'',
      URL:'',
      target:'',

    }
  },
  async created () {
    // load configuration for Pseudocode_LIV_Advertising
    let response = await mtapi.axios.get(
      `/api/ContentItem?ContentKey=${this.ContentKey}&ContentItemKey=${this.ContentItemKey}`
    )
    if (response?.data?.$type?.startsWith(`Asi.Soa.Core.DataContracts.PagedResult`))
      this.config = response?.data?.Items?.$values[0]?.Data
    else
      this.config = response?.data

      this.setImage();
      
      
    // once all data loaded ok to mount the component
    this.ready = (this.imagePath)?true:false;
  },
  	methods:{
		setImage(){
			let index		=	this.getRandomNumberBetween(0,this.config.Settings.images?.length-1)
			this.imagePath 	= 	this.config.Settings.images[index]?.path;
			this.URL 		= 	this.config.Settings.images[index]?.url;
			this.isNewTab 	= 	this.config.Settings.newTab;
			this.target		=	(this.isNewTab)?'_blank':'';
			this.$nextTick(()=>{
				const livadverts	=	document.querySelectorAll('.livadvert.Billboard');
				[...livadverts].forEach(a=>{
					let targetid	=	a.dataset.targetid;
					let targetelm	=	document.getElementById(targetid);
					if(targetelm){
						a.classList.remove('Billboard');
						a.classList.add('livbillboard');
						targetelm.appendChild(a);
					}
				});
			});
		},
		getRandomNumberBetween(min,max){
			return Math.floor(Math.random()*(max-min+1)+min);
		}
  	}
}
</script>

<style scoped lang="scss">
.app {
  color: inherit;
}
.Billboard{ display: none; }
</style>
<style>
.livbillboard{ display: block; width: 100%; margin: 0 0 30px; }
	.livbillboard img{ display: block; width: 100%; }
</style>
